import { createEntitySlice } from '@/shared/store/createEntitySlice';
import { discountsApi } from '../api';
import type { Discount, DiscountFilters, DiscountFormData } from '../types';

const initialState = {
  items: [] as Discount[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 10,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    type: '',
  } as DiscountFilters,
};

const { actions, reducer } = createEntitySlice<Discount, DiscountFilters, DiscountFormData>({
  name: 'discounts',
  api: discountsApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.discounts;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search) {
      params.search = filters.search;
    }

    if (filters.type) {
      const type = filters.type.trim();
      if (type === 'percent') {
        params.type = 'Discount Percent';
      } else if (type === 'fixed') {
        params.type = 'Discount Amount';
      }
    }

    return params;
  },
});

export const {
  fetchItems: fetchDiscounts,
  createItem: createDiscount,
  updateItem: updateDiscount,
  deleteItem: deleteDiscount,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
